import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { performStepUpMfa } from './thunks';
import { MfaState, StepUpMfaResult } from './types';

export const initialState: MfaState = {
  mfaUserId: null,
  service: '',
  dialogOpen: false,
  dialogState: 'verifying',
  errorMessage: '',
  actionType: 'window',
  attemptsRemaining: null,
  challengeId: null,
};

export const mfaSlice = createSlice({
  name: '@@common/mfa',
  initialState,
  reducers: {
    closeMfaDialog: (state) => {
      state.dialogOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(performStepUpMfa.pending, (state, action) => {
      if (state.attemptsRemaining === 0) return; // stay locked, thunk will reject immediately
      state.dialogOpen = true;
      state.dialogState = 'verifying';
      state.errorMessage = '';
      state.mfaUserId = initialState.mfaUserId;
      state.actionType = action.meta.arg.actionType;
      state.service = action.meta.arg.service;
    });
    builder.addCase(performStepUpMfa.fulfilled, (state, action: PayloadAction<StepUpMfaResult>) => {
      state.mfaUserId = action.payload.userId;
      state.service = action.payload.service;
      state.dialogState = 'success';
      state.attemptsRemaining = null;
      state.challengeId = null;
    });
    builder.addCase(performStepUpMfa.rejected, (state, action) => {
      const failure = action.payload;
      if (failure?.isLocked) {
        state.dialogOpen = true;
        state.dialogState = 'locked';
        state.attemptsRemaining = 0;
        state.challengeId = null;
      } else {
        state.dialogState = 'error';
        if (failure) {
          state.attemptsRemaining = failure.attemptsRemaining;
          state.challengeId = failure.challengeId;
        }
      }
      state.errorMessage = failure?.error || action.error.message || 'Verification failed.';
    });
  },
});

export const { closeMfaDialog } = mfaSlice.actions;
